// Import 3rd party libraries
import { Fancybox } from "@fancyapps/ui";

// Import css
import "@fancyapps/ui/dist/fancybox/fancybox.css";

(() => {
    Fancybox.bind();
})()